/** A drag paints one note state; re-entering a tile never toggles it again. */
export class MarkStroke {
  constructor({ perform, state }) {
    this.perform = perform;
    this.state = state;
    this.end();
  }
  begin(index) {
    this.end();
    if (!this.state().prefs.dragMark) return;
    this.stroke = {
      token: {},
      marked: !this.state().marks.includes(index),
      visited: new Set(),
    };
  }
  paint(indices) {
    if (!this.stroke || !this.state().prefs.dragMark) return;
    const fresh = indices.filter((index) => {
      if (this.stroke.visited.has(index)) return false;
      this.stroke.visited.add(index);
      return true;
    });
    if (!fresh.length) return;
    return this.perform("paintMarks", {
      indices: fresh,
      marked: this.stroke.marked,
      stroke: this.stroke.token,
    });
  }
  end() {
    this.stroke = null;
  }
}
